import { Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { RiFileExcel2Line, RiSearch2Line } from "react-icons/ri";
import { SlReload } from "react-icons/sl";
import arrow from "../../../assets/images/arrow.png";

import { LuUpload } from "react-icons/lu";

import { FiPlus, FiUser } from "react-icons/fi";
import { ExportToExcel } from "../../../utils/exportExcel";

import CreateUser from "./components/CreateUser";
import UploadSign from "./components/UploadSign";
import UpdateUser from "./components/UpdateUser";
import { useQuery } from "@tanstack/react-query";
import Something from "../../../components/shared/Something";
import ResetPassword from "./components/ResetPassword";
import UploadUnits from "./components/UploadUnits";
import { handleExportUnits, handleFetchUnits } from "../../../api/units";
import UnitDetails from "./components/UnitDetails";
import AssignApprover from "./components/AssignApprover";
import getInitials from "../../../utils/getInitials";
import RemoveApprover from "./components/RemoveApprover";
import NoAssignee from "./components/NoAssignee";
import Approver from "./components/Approver";
import { AuthContext } from "../../../contexts/AuthContext";

export default function Units() {
  const { unit, setUnit, auth } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [resetModal, setResetModal] = useState<boolean>(false);
  const [signModal, setSignModal] = useState<boolean>(false);
  const [deleteApproverModal, setDeleteApproverModal] =
    useState<boolean>(false);
  const [assignModal, setAssignModal] = useState<boolean>(false);
  const [detailsModal, setDetailsModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [isExporting, setExporting] = useState<boolean>(false);
  const [selectedApprover, setSelectedApprover] = useState<any>({});
  const [type, setType] = useState<any>(null);
  const access = [4, 5, 9];

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const params = `shown=1`;

  const {
    data: units,
    refetch,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["units"],
    queryFn: () => handleFetchUnits({ params }),
  });

  const handleDelete = async ({ item, type }: any) => {
    setDeleteApproverModal(true);
    setSelectedApprover(item);
    setType(type);
  };
  const handleRefetch = () => {
    refetch();
  };

  const exportUnits = async () => {
    setExporting(true);
    const units = await handleExportUnits();
    await ExportToExcel(
      units?.map((item: any) => {
        return {
          NAME: item?.name || "-",
          ACTIVE: item?.isActive ? "Yes" : "No",
        };
      }),
      "Units.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: units?.total });
    if (!unit) {
      setUnit(units?.records[0]);
    }
  }, [units]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white">
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="p-2">
            <div className="grid grid-cols-12 gap-x-4">
              <div className="col-span-10 sm:col-span-4 md:col-span-3">
                {units?.records?.length > 0 && (
                  <div className="">
                    {units?.records?.map((item: any, index: number) => (
                      <div
                        onClick={() => {
                          setUnit({
                            ...item,
                          });
                        }}
                        key={index}
                        className={`border rounded-md p-2 cursor-pointer hover:bg-gray-200 mb-2 ${
                          unit?._id === item?._id ? "bg-gray-200" : ""
                        }`}
                      >
                        <div className="border-b-2 border-gray-300 pb-2 sm:pb-0 sm:border-none">
                          {item?.name}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="col-span-12 sm:col-span-8 md:col-span-9 hidden sm:block">
                <div className="border-b-4 pb-2 pt-2 font-bold mb-2 flex justify-between">
                  <div className="">
                    <div className="text-fish">APPROVAL MATRIX</div>
                    <div className="">
                      {unit?.name || "Select Business Unit"}
                    </div>
                  </div>
                  <div className="flex">
                    <Tooltip title="Export To Excel">
                      <button
                        className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                        onClick={() => exportUnits()}
                      >
                        {isExporting ? (
                          <SlReload />
                        ) : (
                          <RiFileExcel2Line size={20} />
                        )}
                      </button>
                    </Tooltip>

                    {access.includes(auth?.accessLevel) && (
                      <div className="flex">
                        <button
                          onClick={() => setUploadModal(true)}
                          className="flex mx-2 justify-center items-center border px-4 h-8   hover:bg-gray-100"
                        >
                          <LuUpload /> <span className="mx-2">Upload</span>
                        </button>
                        <button
                          onClick={() => setCreateModal(true)}
                          className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                        >
                          <FiPlus size={13} /> <span className="mx-2">New</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex justify-between">
                  <div className="mb-2">
                    List of Approvers for Business Unit {selected?.name}
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  {/* INITIATORS */}
                  <div className="border w-80 p-2 flex flex-col items-center">
                    <div className="text-center font-bold">Initiators</div>
                    {unit?.approvals?.initiators?.length > 0 ? (
                      <div className="flex flex-col items-center">
                        {unit?.approvals?.initiators?.map(
                          (item: any, index: number) => (
                            <Approver
                              item={item}
                              key={index}
                              access={access}
                              handleDelete={handleDelete}
                              type={"Initiator"}
                            />
                          )
                        )}
                      </div>
                    ) : (
                      <NoAssignee />
                    )}

                    {access.includes(auth?.accessLevel) && (
                      <button
                        onClick={() => {
                          setType("Initiator");
                          setAssignModal(true);
                        }}
                        className="border px-4 py-1"
                      >
                        + Assign
                      </button>
                    )}
                  </div>
                  <div className="mb-1 flex justify-center">
                    <img src={arrow} alt="" width={8} />
                  </div>
                  <div className="flex">
                    {/* FINANCIAL CONTROLLERS */}

                    <div className="">
                      <div className="border w-80 p-2 flex flex-col items-center">
                        <div className="text-center font-bold">
                          Credit Controllers
                        </div>
                        {unit?.approvals?.financialControllers?.length > 0 ? (
                          <div className="flex flex-col items-center">
                            {unit?.approvals?.financialControllers?.map(
                              (item: any, index: number) => (
                                <Approver
                                  item={item}
                                  key={index}
                                  access={access}
                                  handleDelete={handleDelete}
                                  type={"Financial Controller"}
                                />
                              )
                            )}
                          </div>
                        ) : (
                          <NoAssignee />
                        )}
                        {access.includes(auth?.accessLevel) && (
                          <button
                            onClick={() => {
                              setType("Financial Controller");
                              setAssignModal(true);
                            }}
                            className="border px-4 py-1"
                          >
                            + Assign
                          </button>
                        )}
                      </div>
                      <div className="mb-1 flex justify-center">
                        <img src={arrow} alt="" width={8} />
                      </div>
                    </div>
                  </div>

                  {/* EXECUTIVES */}
                  <div className="">
                    <div className="border w-80 p-2 flex flex-col items-center">
                      <div className="text-center font-bold">
                        Business Unit Heads
                      </div>
                      {unit?.approvals?.executives?.length > 0 ? (
                        <div className="flex flex-col items-center">
                          {unit?.approvals?.executives?.map(
                            (item: any, index: number) => (
                              <Approver
                                item={item}
                                key={index}
                                access={access}
                                handleDelete={handleDelete}
                                type={"Executive"}
                              />
                            )
                          )}
                        </div>
                      ) : (
                        <NoAssignee />
                      )}
                      {access.includes(auth?.accessLevel) && (
                        <button
                          onClick={() => {
                            setType("Executive");
                            setAssignModal(true);
                          }}
                          className="border px-4 py-1"
                        >
                          + Assign
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <CreateUser
        isVisible={createModal}
        setVisible={setCreateModal}
        refetch={handleRefetch}
      />

      <UpdateUser
        isVisible={updateModal}
        setVisible={setUpdateModal}
        refetch={refetch}
        selected={unit}
      />

      <RemoveApprover
        isVisible={deleteApproverModal}
        setVisible={setDeleteApproverModal}
        refetch={refetch}
        selected={unit}
        approver={selectedApprover}
        type={type}
      />

      <AssignApprover
        isVisible={assignModal}
        setVisible={setAssignModal}
        selected={unit}
        type={type}
      />
      <UploadSign
        isVisible={signModal}
        setVisible={setSignModal}
        selected={selected}
        refetch={refetch}
      />

      <UploadUnits
        isVisible={uploadModal}
        setVisible={setUploadModal}
        selected={unit}
        refetch={refetch}
      />

      <UnitDetails
        isVisible={detailsModal}
        setVisible={setDetailsModal}
        selected={unit}
        refetch={refetch}
      />

      <ResetPassword
        isVisible={resetModal}
        setVisible={setResetModal}
        refetch={refetch}
        selected={unit}
      />
    </div>
  );
}
